class Sgn {
    run(value) {
        return value < -1e-12 ? -1 : 1
    }
}

export default Sgn;